"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LensProfileCard_1 = require("./LensProfileCard");
const PremiumProfileCard_1 = require("./PremiumProfileCard");
const PublicUserProfileCard_1 = require("./PublicUserProfileCard");
var ProfileType;
(function (ProfileType) {
    ProfileType["Publisher"] = "Publisher";
    ProfileType["PublicProfileUser"] = "PublicProfileUser";
    ProfileType["LensProfile"] = "LensProfile";
})(ProfileType || (ProfileType = {}));
/**
 * Profile Card component for rendering various types of profiles
 */
function ProfileCard(props) {
    switch (props.type) {
        case ProfileType.Publisher:
            return ((0, jsx_runtime_1.jsx)(PremiumProfileCard_1.PremiumProfileCard, { premiumProfileInfo: props.profileInfo, width: props.width, height: props.height, logCardClick: props.logCardClick }));
        case ProfileType.LensProfile:
            return ((0, jsx_runtime_1.jsx)(LensProfileCard_1.LensProfileCard, { width: props.width, height: props.height, lensProfileInfo: props.profileInfo, logCardClick: props.logCardClick }));
        case ProfileType.PublicProfileUser:
            return ((0, jsx_runtime_1.jsx)(PublicUserProfileCard_1.PublicUserProfileCard, { publicUserProfileInfo: props.profileInfo, width: props.width, height: props.height, logCardClick: props.logCardClick }));
    }
}
exports.ProfileCard = ProfileCard;
//# sourceMappingURL=ProfileCard.js.map